import { MovePayload } from 'pages/NestedCustomers/types'
import { WalletTransferType } from 'types/unifiedPayouts/unifiedPayouts'

export const getFieldsToValidate = (
  walletTransferType: WalletTransferType
): (keyof MovePayload)[] => {
  const fields: (keyof MovePayload)[] = [
    'walletTransferType',
    'destinationWallet',
    'amount',
    'paymentReference',
  ]

  walletTransferType === WalletTransferType.CUSTOMER && fields.push('customerReference')

  return fields
}
